/*
 * @Description: 异常组件封装，包括加载中，加载失败，无数据组件等
 */
import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import Loading from '@/pages/intelligence/components/Loading';
import NoData from '@/pages/intelligence/components/NoData';
import LoadingFailed from '@/pages/intelligence/components/LoadingFailed';

import type { IBaseProps } from '@/pages/intelligence/types/common';

type Node = React.Component | React.ReactNode | string;
interface AbnormalPropsFace extends IBaseProps {
  isLoading: boolean;
  componentLoading?: boolean;
  isError?: boolean;
  isNoData?: boolean;
  loadingMsg?: string;
  failedMsg?: string;
  nodataMsg?: Node;
  component?: any;
}

const Abnormal = (props: AbnormalPropsFace) => {
  const { formatMessage } = useIntl();
  const {
    isLoading = true,
    componentLoading = false,
    isError = false,
    isNoData = false,
    loadingMsg = formatMessage({ id: 'common_loading' }),
    failedMsg = formatMessage({ id: 'common_loading_failed' }),
    nodataMsg = formatMessage({ id: 'common_nodata' }),
    component,
    style,
    className,
  } = props;

  const rootClassName = classnames('', className);

  if (isLoading) {
    return (
      <div
        style={{
          height: 300,
          // color: '#444',
          color: '#262832',
          ...style,
        }}
        className={rootClassName}
      >
        <Loading content={loadingMsg} />
      </div>
    );
  }
  if (isError) {
    return (
      <div
        style={{
          height: 300,
          // color: '#444',
          color: '#262832',
          ...style,
        }}
        className={rootClassName}
      >
        <LoadingFailed failedMsg={failedMsg} />
      </div>
    );
  }
  if (isNoData && !componentLoading) {
    return (
      <div
        style={{
          height: 300,
          // color: '#444',
          color: '#262832',
          ...style,
        }}
        className={rootClassName}
      >
        <NoData text={nodataMsg} />
      </div>
    );
  }

  return (
    <>
      {componentLoading && (
        <div
          style={{
            height: 300,
            // color: '#444',
            color: '#262832',
            ...style,
          }}
          className={rootClassName}
        >
          <Loading content={loadingMsg} />
        </div>
      )}
      {/** 不要用div包裹，会影响样式 */}
      {componentLoading ? null : component}
    </>
  );
};

export default Abnormal;
